<script setup lang="ts">
import { computed } from 'vue';
import { DividerComponent } from '@hfc/ui-core';
import { PlanFilter } from '@/application/smallBusiness/domain/SmallBusinessPlanFilters';
import CheckBoxFilters from '@/application/smallBusiness/infrastructure/components/CheckBoxFilters.vue';
import SampleEmployeeDetails from '@/application/smallBusiness/infrastructure/components/SampleEmployeeDetails.vue';
import ContributionFilters from '@/application/smallBusiness/infrastructure/components/ContributionFilters.vue';
import { useSmallBusinessStore } from '@/application/smallBusiness/infrastructure/composition/useSmallBusinessStore';

const { smallBusinessStore, smallBusinessState } = useSmallBusinessStore();

const availableFilters = computed(() => smallBusinessState.value.availableFilters as Array<PlanFilter>);

const filterPlans = (filters: Array<PlanFilter>): void => {
  smallBusinessStore.setFilters(filters);
};

</script>
<template>
  <SampleEmployeeDetails />
  <DividerComponent />
  <ContributionFilters />
  <DividerComponent />
  <CheckBoxFilters :filters="availableFilters" :loading="smallBusinessState.availablePlansLoading" @update-values="filterPlans" @update-cal-choice="smallBusinessStore.fetchAvailablePlans()" />
</template>
